import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import DateTimeFiltersDialog from "./DateTimeFiltersDialog";
import CallTableViewModel from "../../../ViewModels/CallTableViewModel";
import FilterChipDisplay from "../../FilterChipDisplay";

interface IDateTimeFiltersProps {
    isAgent: boolean
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function DateTimeFilters({ isAgent, callTableViewModel, setCallTableViewModel }: IDateTimeFiltersProps) {
    const [open, setOpen] = useState(false);

    const text = <Typography variant="body1">
        {
            callTableViewModel.filters.dateTimeFilters.preset
        }
        {
            callTableViewModel.filters.dateTimeFilters.preset === "This Week" || callTableViewModel.filters.dateTimeFilters.preset === "Last Week" ? ' starting on ' + callTableViewModel.filters.dateTimeFilters.dayOfWeek : ''
        }
        {
            callTableViewModel.filters.dateTimeFilters.preset === "Single Date" || callTableViewModel.filters.dateTimeFilters.preset === "Date Range" ? ' ' + new Date(callTableViewModel.filters.dateTimeFilters.startDate).toDateString() : ''
        }
        {
            callTableViewModel.filters.dateTimeFilters.preset === "Date Range" ? ' to ' + new Date(callTableViewModel.filters.dateTimeFilters.endDate).toDateString() : ''
        }
        {
            callTableViewModel.filters.dateTimeFilters.flagTimeRange ? ' - Time Range ' + (callTableViewModel.filters.dateTimeFilters.startTime === undefined ? '00:00' : callTableViewModel.filters.dateTimeFilters.startTime) + ' to ' + (callTableViewModel.filters.dateTimeFilters.endTime === undefined ? '00:00' : callTableViewModel.filters.dateTimeFilters.endTime) : ''
        }
    </Typography>

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setOpen(true)} />
            <DateTimeFiltersDialog
                open={open}
                setOpen={setOpen}
                isAgent={isAgent}
                callTableViewModel={callTableViewModel}
                setCallTableViewModel={setCallTableViewModel} />
        </>
    )
}